import ENV from "config/Env";
import { backendQueryKey } from "hooks/useTypedQuery";

import type { InterventionElement } from "models";

const component = "KeyloopSubitemsModal";

export const KeyloopSubitemsModalQueryKeys = {
  search: backendQueryKey<InterventionElement[]>({ component, baseUrl: ENV.appointmentBaseURL, endpoint: "/interventions/element/code/search" })
};
